import styled, { css } from "styled-components";

export const StyledWrapper = styled.div``;

export const StyledFeedbackTag = styled.div`
  span.error {
    margin-bottom: unset;
  }

  div.controls {
    display: flex;
    justify-content: space-between;

    a {
      color: ${({ theme }) => theme.colors.primaryText};
      ${({ theme }) => theme.fontStyles.InterfaceCopy}
    }
  }

  ${({ $readOnly }) =>
    !$readOnly &&
    css`
      padding-top: 12px;
    `}

  ${({ $hidden }) =>
    $hidden &&
    css`
      display: none;
      visibility: hidden;
    `}
`;
